import AccountLayout from '../../components/Account/layouts/AccountLayout';
import Dashboard from '../../modules/account/Dashboard';
import { createCommonGetStaticProps } from '~/lib/server/createCommonGetStaticProps';

export const getStaticProps = createCommonGetStaticProps([
  'bridgeStatus',
  'trips',
  'account',
  'common',
]);

Dashboard.getLayout = function getLayout(page) {
  return (
    <AccountLayout namespace="dashboard" hideMetadata hideNavigation>
      {page}
    </AccountLayout>
  );
};

export default Dashboard;
